import Select from 'react-select';
import makeAnimated from 'react-select/animated';

function SearchableDropDown({
    name,
    data = [],
    value,
    onChange,
    valueKey,
    labelKey,
    labelBuilder,
    disabled
}) {


    const options = (data ?? []).map((item) => ({
        value: valueKey(item),
        label: labelBuilder ? labelBuilder(item) : item[labelKey]
    }));


   const selectedOption =
        value === null || value === undefined || value === ''
            ? null
            : options.find(
                (opt) => String(opt.value) === String(value)
            ) || null;

    return (
        <Select
            name={name}
            components={makeAnimated()}
            options={options}
            value={selectedOption}
            onChange={(e) => onChange(e)}
            disabled={disabled ? disabled : false}
        />
    );
}

export default SearchableDropDown;